var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "moodboard__result" },
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "result__headline" }, [
              _vm._v(_vm._s(_vm.$t("results"))),
            ]),
          ]),
          _vm._v(" "),
          _vm.decors === null
            ? [
                _vm._l(_vm.showedDecors, function (placeholder) {
                  return [
                    _c("div", { staticClass: "col-6 col-md-4 col-lg-2" }, [
                      _vm._m(0, true),
                    ]),
                  ]
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.decors, function (decorSet, column) {
            return [
              _c(
                "div",
                {
                  staticClass: "col-6 col-md-4 col-lg-2",
                  class: _vm.debug ? "debug" : "",
                },
                [
                  _vm._l(decorSet, function (decor, row) {
                    return [
                      _vm.debug
                        ? _c(
                            "div",
                            [
                              _c("global-material-tile", {
                                attrs: { entity: decor },
                              }),
                            ],
                            1
                          )
                        : [
                            _vm.showedDecors[column] === row
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "global-material-tile",
                                      { attrs: { entity: decor } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "button-wrapper bottom left",
                                            attrs: { slot: "content-wrapper" },
                                            slot: "content-wrapper",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "button button--primary",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.newSuggestion(
                                                      column,
                                                      decorSet.length
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("newMatch"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                    ]
                  }),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "button-wrapper bottom right spaced--responsive full-width--xs spacer--top-none",
        },
        [
          _vm.showRoomdesignerButton
            ? _c(
                "button",
                {
                  staticClass:
                    "button button--secondary icon--before icon--roomdesigner",
                  attrs: { disabled: _vm.roomdesignerButtonIsDisabled },
                  on: {
                    click: function ($event) {
                      _vm.showRoomdesignerModal = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("toRoomDesigner")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "button button--primary icon--before icon--wishlist-empty",
              attrs: { disabled: _vm.paletteIsOnWishlist() },
              on: { click: _vm.addToWishlist },
            },
            [_vm._v(_vm._s(_vm.$t("savePalette")))]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showRoomdesignerButton
        ? _c("global-roomdesigner-selection", {
            attrs: { initialData: _vm.roomdesignerModalData },
            on: {
              done: function ($event) {
                _vm.showRoomdesignerModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "result__placeholder" }, [
      _c("img", {
        staticClass: "placeholder__spinner",
        attrs: {
          alt: "loading spinner",
          src: require("../assets/icon-spinner.svg"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }